import script from "./TradeTrackerForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeTrackerForm.vue?vue&type=script&setup=true&lang=js"

import "./TradeTrackerForm.vue?vue&type=style&index=0&id=5d7fc82c&lang=scss"

const __exports__ = script;

export default __exports__